import React from 'react';
import { AlertTriangle, AlertCircle, CheckCircle, Info } from 'lucide-react';

const variantStyles = {
  default: {
    background: 'bg-white border-gray-200',
    titleColor: 'text-gray-900',
    descColor: 'text-gray-600',
    icon: 'text-gray-500'
  },
  destructive: {
    background: 'bg-red-50 border-red-200',
    titleColor: 'text-red-900',
    descColor: 'text-red-700',
    icon: 'text-red-500'
  },
  warning: {
    background: 'bg-yellow-50 border-yellow-200',
    titleColor: 'text-yellow-900',
    descColor: 'text-yellow-700',
    icon: 'text-yellow-500'
  },
  success: {
    background: 'bg-green-50 border-green-200',
    titleColor: 'text-green-900',
    descColor: 'text-green-700',
    icon: 'text-green-500'
  },
  info: {
    background: 'bg-blue-50 border-blue-200',
    titleColor: 'text-blue-900',
    descColor: 'text-blue-700',
    icon: 'text-blue-500'
  }
};

const getIcon = (variant) => {
  switch(variant) {
    case 'destructive': return AlertCircle;
    case 'warning': return AlertTriangle;
    case 'success': return CheckCircle;
    case 'info': return Info;
    default: return Info;
  }
};

export const Alert = ({ 
  variant = 'default', 
  title, 
  description, 
  children, 
  className = '',
  ...props 
}) => {
  const styles = variantStyles[variant] || variantStyles.default;
  const Icon = getIcon(variant);

  return (
    <div 
      className={`
        flex items-start 
        p-4 border rounded-lg 
        ${styles.background} 
        ${className}
      `} 
      {...props}
    >
      <div className="flex-shrink-0 mr-4">
        <Icon className={`h-6 w-6 ${styles.icon}`} />
      </div>
      <div className="flex-1">
        {title && (
          <h3 className={`text-sm font-semibold ${styles.titleColor}`}>
            {title}
          </h3>
        )}
        {description && (
          <p className={`text-sm mt-1 ${styles.descColor}`}>
            {description}
          </p>
        )}
        {children}
      </div>
    </div>
  );
};

export const AlertTitle = ({ children, className = '', ...props }) => (
  <h3 
    className={`text-sm font-semibold text-gray-900 ${className}`} 
    {...props}
  >
    {children}
  </h3>
);

export const AlertDescription = ({ children, className = '', ...props }) => (
  <p 
    className={`text-sm text-gray-600 mt-1 ${className}`} 
    {...props}
  >
    {children}
  </p>
);